import {Component, EventEmitter, Inject, Input, OnInit, Output, OnDestroy, Optional } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TaxReturnService } from "../../../../../../swaggerServices";
import { ConfigStateService } from "../../../../../app/config/config-state.service";
import { Tenant } from "../../../../types/tenant.enum";

@Component({
    selector: "batch-send-package",
    templateUrl: "./batch-send-package.component.html",
    styleUrls: ["./batch-send-package.component.scss"],
    standalone: false
})
export class BatchSendPackage implements OnInit, OnDestroy {
  @Input() selectedTaxReturns;
  @Input() batchId;
  @Input() clientId;
  @Input() year;
  @Input() genType;
  @Input() taxReturnAlias: string;

  @Output() completed = new EventEmitter();
  showModal = true;
  responseData = [];
  batchActionState: "OPENED" | "LOADING" | "COMPLETED" = null;
  errorMessage = "";
  tenants: any;

  private unsubscribe: Subject<void> = new Subject();
  constructor(private taxReturnService: TaxReturnService,
    private config: ConfigStateService,
    @Optional() private dialogRef?: MatDialogRef<BatchSendPackage>,
    @Optional() @Inject(MAT_DIALOG_DATA) data?: Partial<BatchSendPackage>) {
    Object.assign(this, data);
  }

  get selectedTaxReturnIds() {
    return this.selectedTaxReturns ?  Object.keys(this.selectedTaxReturns).map(n=>Number(n)) : [];
  }

  get submitButtonDisabled() {
    return !this.batchId || this.batchActionState==='LOADING';
  }

  ngOnInit() {
    this.tenants = Tenant;
    this.batchActionState = 'OPENED';
    this.errorMessage = '';
    if (!this.batchId) {
      this.errorMessage = 'This action can only be applied to a batch. Select a batch and try again.';
      return;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  batchGenerate() {
    this.errorMessage = '';
    this.batchActionState = 'LOADING';
    this.taxReturnService.batchSendFinalPackage({
      taxReturnIds: this.selectedTaxReturnIds,
        batchId: parseInt(this.batchId),
        clientId: parseInt(this.clientId),
        taxYear: parseInt(this.year),
    })
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(resp => {
      this.batchActionState = 'COMPLETED';
    }, error => {
      this.errorMessage = "Something went wrong, please try again later.";
      this.batchActionState = 'OPENED';
      return;
    });
  }

  onClose(result: boolean = false) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
      return;
    }
    this.showModal = false;
    this.completed.emit();
  }

}
